import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 right-0 bottom-0 z-[100] w-full sm:w-[420px] bg-background border-l shadow-2xl flex flex-col"
}
const _hoisted_2 = { class: "h-14 border-b px-4 flex items-center justify-between shrink-0" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { class: "px-4 py-3 border-b bg-muted/30 shrink-0" }
const _hoisted_6 = { class: "grid grid-cols-5 gap-2 text-center" }
const _hoisted_7 = { class: "text-lg font-bold text-red-600" }
const _hoisted_8 = { class: "text-lg font-bold text-red-500" }
const _hoisted_9 = { class: "text-lg font-bold text-orange-500" }
const _hoisted_10 = { class: "text-lg font-bold text-blue-500" }
const _hoisted_11 = { class: "text-lg font-bold text-muted-foreground" }
const _hoisted_12 = { class: "flex-1 overflow-y-auto" }
const _hoisted_13 = {
  key: 0,
  class: "p-4 space-y-3"
}
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-full px-4"
}
const _hoisted_15 = { class: "px-4 pt-3 space-y-2 shrink-0" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_18 = { class: "flex items-center gap-1.5 mb-2" }
const _hoisted_19 = { class: "space-y-1.5" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "flex-1 min-w-0" }
const _hoisted_22 = { class: "text-sm font-medium truncate" }
const _hoisted_23 = { class: "flex items-center gap-2 mt-0.5" }
const _hoisted_24 = { class: "text-[11px] text-red-500" }
const _hoisted_25 = {
  key: 0,
  class: "text-[10px] text-muted-foreground"
}
const _hoisted_26 = {
  key: 1,
  class: "text-[10px] text-muted-foreground"
}
const _hoisted_27 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_28 = { class: "flex items-center gap-1.5 mb-2" }
const _hoisted_29 = { class: "text-[10px] text-muted-foreground" }
const _hoisted_30 = { class: "space-y-1.5" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "flex-1 min-w-0" }
const _hoisted_33 = { class: "text-sm truncate" }
const _hoisted_34 = { class: "flex items-center gap-2 mt-0.5" }
const _hoisted_35 = {
  key: 0,
  class: "text-[10px] text-muted-foreground"
}
const _hoisted_36 = {
  key: 1,
  class: "text-[10px] text-muted-foreground"
}
const _hoisted_37 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_38 = {
  key: 0,
  class: "space-y-2 mt-3"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0" }
const _hoisted_41 = { class: "flex-1 min-w-0" }
const _hoisted_42 = { class: "text-sm font-medium truncate" }
const _hoisted_43 = { class: "flex items-center gap-2 mt-0.5" }
const _hoisted_44 = { class: "text-[11px] text-muted-foreground" }
const _hoisted_45 = { class: "text-[11px] text-muted-foreground" }
const _hoisted_46 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-12"
}

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useTasksWidget } from '@/composables/useTasksWidget'
import { useTasksStore } from '@/views/Tasks/store'
import { useTaskBoardsStore } from '@/views/Tasks/store/boards'
import { useAuthStore } from '@/stores/auth'
import { formatDate } from '@/utils/formatters'
import type { Task, Priority } from '@/types'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import type { Component } from 'vue'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs'
import {
  CheckSquare,
  Minus,
  X,
  AlertTriangle,
  Clock,
  ArrowRight,
  Inbox,
  ExternalLink,
  Calendar,
  Flame,
  CircleDot,
  CheckCircle2,
  LayoutGrid,
  Search,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'TasksPanel',
  setup(__props) {

const { isOpen, minimize, close } = useTasksWidget()
const store = useTasksStore()
const boardsStore = useTaskBoardsStore()
const authStore = useAuthStore()
const router = useRouter()
const searchQuery = ref('')

const priorityConfig: Record<Priority, { label: string; color: string }> = {
  critical: { label: 'Critico', color: 'text-red-500 bg-red-500/10' },
  high: { label: 'Alto', color: 'text-orange-500 bg-orange-500/10' },
  medium: { label: 'Medio', color: 'text-blue-500 bg-blue-500/10' },
  low: { label: 'Bajo', color: 'text-muted-foreground bg-muted' },
}

const now = new Date()

// Filter from global store: only tasks assigned to current user + search
const myTasks = computed(() => {
  let tasks = store.tasks.filter((t) => t.assignedTo?.includes(authStore.userId || ''))
  if (searchQuery.value.trim()) {
    const q = searchQuery.value.toLowerCase()
    tasks = tasks.filter((t) =>
      t.title.toLowerCase().includes(q) ||
      (t.taskNumber && `#${t.taskNumber}`.includes(q)) ||
      t.description?.toLowerCase().includes(q)
    )
  }
  return tasks
})

const overdueTasks = computed(() =>
  myTasks.value.filter((t) => t.dueDate && t.dueDate < now && t.status !== 'done' && t.status !== 'cancelled')
)

const criticalTasks = computed(() =>
  myTasks.value.filter((t) => t.priority === 'critical' && t.status !== 'done' && t.status !== 'cancelled')
)

const highTasks = computed(() =>
  myTasks.value.filter((t) => t.priority === 'high' && t.status !== 'done' && t.status !== 'cancelled')
)

const mediumTasks = computed(() =>
  myTasks.value.filter((t) => t.priority === 'medium' && t.status !== 'done' && t.status !== 'cancelled')
)

const lowTasks = computed(() =>
  myTasks.value.filter((t) => t.priority === 'low' && t.status !== 'done' && t.status !== 'cancelled')
)

const activeTasks = computed(() =>
  myTasks.value.filter((t) => t.status !== 'done' && t.status !== 'cancelled')
)

const recentTasks = computed(() =>
  myTasks.value.slice(0, 15)
)

const getBoardName = (boardId?: string) => {
  if (!boardId) return null
  return boardsStore.boardById(boardId)?.name || null
}

const navigateToTask = (task: Task) => {
  close()
  router.push(`/tasks/${task.id}`)
}

const navigateToBoard = (boardId: string) => {
  close()
  router.push(`/tasks/board/${boardId}`)
}

const navigateToBoards = () => {
  close()
  router.push('/tasks')
}

const isOverdue = (task: Task) =>
  task.dueDate && task.dueDate < now && task.status !== 'done' && task.status !== 'cancelled'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0 translate-x-full",
      "enter-to-class": "opacity-100 translate-x-0",
      "leave-from-class": "opacity-100 translate-x-0",
      "leave-to-class": "opacity-0 translate-x-full"
    }, {
      default: _withCtx(() => [
        (_unref(isOpen))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(CheckSquare), { class: "h-5 w-5 text-primary" }),
                  _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "font-semibold" }, "Mis Tareas", -1)),
                  (overdueTasks.value.length > 0)
                    ? (_openBlock(), _createBlock(_unref(Badge), {
                        key: 0,
                        variant: "destructive",
                        class: "text-[10px] px-1.5 py-0"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(overdueTasks.value.length) + " vencidas ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    class: "h-8 w-8",
                    onClick: navigateToBoards,
                    title: "Ir a tableros"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ExternalLink), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    class: "h-8 w-8",
                    onClick: _unref(minimize),
                    title: "Minimizar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Minus), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    class: "h-8 w-8",
                    onClick: _unref(close),
                    title: "Cerrar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(X), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(overdueTasks.value.length), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-[10px] text-muted-foreground" }, "Vencidas", -1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(criticalTasks.value.length), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-[10px] text-muted-foreground" }, "Critico", -1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(highTasks.value.length), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-[10px] text-muted-foreground" }, "Alto", -1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(mediumTasks.value.length), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-[10px] text-muted-foreground" }, "Medio", -1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(lowTasks.value.length), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-[10px] text-muted-foreground" }, "Bajo", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_unref(store).isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                        return _createVNode(_unref(Skeleton), {
                          key: i,
                          class: "h-16 w-full"
                        })
                      }), 64))
                    ]))
                  : (myTasks.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_unref(Inbox), { class: "h-10 w-10 text-muted-foreground mb-3" }),
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-muted-foreground mb-4" }, "No tienes tareas asignadas", -1)),
                        _createVNode(_unref(Button), {
                          variant: "outline",
                          size: "sm",
                          onClick: navigateToBoards
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(LayoutGrid), { class: "mr-2 h-3.5 w-3.5" }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Ver tableros ", -1))
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(Tabs), {
                        key: 2,
                        "default-value": "tasks",
                        class: "flex flex-col h-full"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_unref(TabsList), { class: "w-full" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(TabsTrigger), {
                                  value: "tasks",
                                  class: "flex-1 text-xs gap-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Flame), { class: "h-3 w-3" }),
                                    _cache[9] || (_cache[9] = _createTextVNode(" Mis tareas ", -1)),
                                    (activeTasks.value.length > 0)
                                      ? (_openBlock(), _createBlock(_unref(Badge), {
                                          key: 0,
                                          variant: "secondary",
                                          class: "text-[9px] px-1 py-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activeTasks.value.length), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(TabsTrigger), {
                                  value: "boards",
                                  class: "flex-1 text-xs gap-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(LayoutGrid), { class: "h-3 w-3" }),
                                    _cache[10] || (_cache[10] = _createTextVNode(" Tableros ", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_unref(Search), { class: "absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" }),
                              _createVNode(_unref(Input), {
                                modelValue: searchQuery.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                                placeholder: "Buscar tarea...",
                                class: "h-8 pl-8 text-xs"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createVNode(_unref(TabsContent), {
                            value: "tasks",
                            class: "flex-1 overflow-y-auto px-4 pb-4 mt-0"
                          }, {
                            default: _withCtx(() => [
                              (overdueTasks.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_unref(AlertTriangle), { class: "h-3.5 w-3.5 text-red-500" }),
                                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-xs font-semibold text-red-500 uppercase tracking-wider" }, "Vencidas", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overdueTasks.value, (task) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: task.id,
                                          class: "w-full flex items-start gap-3 p-2.5 rounded-lg border border-red-500/20 bg-red-500/5 hover:bg-red-500/10 transition-colors text-left",
                                          onClick: ($event: any) => (navigateToTask(task))
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["h-6 w-6 rounded flex items-center justify-center shrink-0 mt-0.5", priorityConfig[task.priority]?.color])
                                          }, [
                                            _createVNode(_unref(AlertTriangle), { class: "h-3 w-3" })
                                          ], 2),
                                          _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("p", _hoisted_22, _toDisplayString(task.title), 1),
                                            _createElementVNode("div", _hoisted_23, [
                                              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(formatDate)(task.dueDate!)), 1),
                                              (task.taskNumber)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "#" + _toDisplayString(task.taskNumber), 1))
                                                : _createCommentVNode("", true),
                                              (getBoardName(task.boardId))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(getBoardName(task.boardId)), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createVNode(_unref(ArrowRight), { class: "h-3.5 w-3.5 text-muted-foreground shrink-0 mt-1" })
                                        ], 8, _hoisted_20))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                { tasks: criticalTasks.value, label: 'Critico', icon: _unref(Flame), color: 'text-red-500' },
                { tasks: highTasks.value, label: 'Alto', icon: _unref(AlertTriangle), color: 'text-orange-500' },
                { tasks: mediumTasks.value, label: 'Medio', icon: _unref(CircleDot), color: 'text-blue-500' },
                { tasks: lowTasks.value, label: 'Bajo', icon: _unref(Clock), color: 'text-muted-foreground' },
              ], (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: group.label
                                }, [
                                  (group.tasks.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(group.icon), {
                                            class: _normalizeClass(["h-3.5 w-3.5", group.color])
                                          }, null, 8, ["class"])),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["text-xs font-semibold uppercase tracking-wider", group.color])
                                          }, _toDisplayString(group.label), 3),
                                          _createElementVNode("span", _hoisted_29, "(" + _toDisplayString(group.tasks.length) + ")", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tasks, (task) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: task.id,
                                              class: "w-full flex items-start gap-3 p-2.5 rounded-lg border hover:bg-muted/50 transition-colors text-left",
                                              onClick: ($event: any) => (navigateToTask(task))
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["h-6 w-6 rounded flex items-center justify-center shrink-0 mt-0.5", priorityConfig[task.priority]?.color])
                                              }, [
                                                (_openBlock(), _createBlock(_resolveDynamicComponent(group.icon), { class: "h-3 w-3" }))
                                              ], 2),
                                              _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("p", _hoisted_33, _toDisplayString(task.title), 1),
                                                _createElementVNode("div", _hoisted_34, [
                                                  (task.taskNumber)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "#" + _toDisplayString(task.taskNumber), 1))
                                                    : _createCommentVNode("", true),
                                                  (getBoardName(task.boardId))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(getBoardName(task.boardId)), 1))
                                                    : _createCommentVNode("", true),
                                                  (task.dueDate)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 2,
                                                        class: _normalizeClass(["text-[10px] flex items-center gap-0.5", isOverdue(task) ? 'text-red-500' : 'text-muted-foreground'])
                                                      }, [
                                                        _createVNode(_unref(Calendar), { class: "h-2.5 w-2.5" }),
                                                        _createTextVNode(" " + _toDisplayString(_unref(formatDate)(task.dueDate)), 1)
                                                      ], 2))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createVNode(_unref(ArrowRight), { class: "h-3.5 w-3.5 text-muted-foreground shrink-0 mt-1" })
                                            ], 8, _hoisted_31))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (activeTasks.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createVNode(_unref(CheckCircle2), { class: "h-10 w-10 text-emerald-500 mb-3" }),
                                    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm font-medium" }, "Todo al día", -1)),
                                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "No tienes tareas activas", -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(TabsContent), {
                            value: "boards",
                            class: "flex-1 overflow-y-auto px-4 pb-4 mt-0"
                          }, {
                            default: _withCtx(() => [
                              (_unref(boardsStore).boards.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(boardsStore).boards, (board) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: board.id,
                                        class: "w-full flex items-start gap-3 p-3 rounded-lg border hover:bg-muted/50 transition-colors text-left",
                                        onClick: ($event: any) => (navigateToBoard(board.id))
                                      }, [
                                        _createElementVNode("div", _hoisted_40, [
                                          _createVNode(_unref(LayoutGrid), { class: "h-4 w-4 text-primary" })
                                        ]),
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("p", _hoisted_42, _toDisplayString(board.name), 1),
                                          _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("span", _hoisted_44, _toDisplayString(board.lists?.length || 0) + " listas", 1),
                                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-[11px] text-muted-foreground" }, "·", -1)),
                                            _createElementVNode("span", _hoisted_45, _toDisplayString(board.members?.length || 0) + " miembros", 1)
                                          ])
                                        ]),
                                        _createVNode(_unref(ArrowRight), { class: "h-3.5 w-3.5 text-muted-foreground shrink-0 mt-2" })
                                      ], 8, _hoisted_39))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createVNode(_unref(LayoutGrid), { class: "h-10 w-10 text-muted-foreground mb-3" }),
                                    _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Sin tableros disponibles", -1))
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})